module.exports = __webpack_public_path__ + "static/media/30under30.aac0fd71.svg";